import { Component } from '@angular/core';
import {ModalController, NavParams} from '@ionic/angular';

@Component({
  selector: 'app-logout-component',
  templateUrl: './logout-component.html',
  styleUrls: ['./logout-component.scss'],
})
export class LogoutComponent {
  id: any;
  codigo: any;

  emptyState = {
    title: 'Deseja realmente sair do sistema?',
    imgLogout: 'assets/imgs/bg-logout.svg',
    text: ''
  }

  constructor(
    private modalController: ModalController,
  ) {
  }

  ionViewDidEnter() {

  }

  async fechar() {
    await this.modalController.dismiss();
  }

  async logout() {
    await this.modalController.dismiss(true);
  }
}
